import { render, staticRenderFns } from "./ServiceRowAlert.vue?vue&type=template&id=3d8fab9b&scoped=true&"
import script from "./ServiceRowAlert.vue?vue&type=script&lang=js&"
export * from "./ServiceRowAlert.vue?vue&type=script&lang=js&"
import style0 from "./ServiceRowAlert.vue?vue&type=style&index=0&id=3d8fab9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8fab9b",
  null
  
)

export default component.exports